<script>
import TwButton from '@/components/generic/tw-button.vue'
import OrganizationRegisterModal from '@/components/organizations/organization-register-modal.vue'

export default {
  name: 'HomeSlider',
  components: { OrganizationRegisterModal, TwButton }
}
</script>

<template>
  <div class="px-4 py-10 mb-4 md:py-24 md:my-6 text-white text-center">
    <h5>
      #1 free fundraising platform for groups & teams
    </h5>
    <div class="my-5 mx-auto max-w-4xl">
      <h1>
        Unleash the Power of <span class="text-amber-500">Crowd Fundraising</span> for Your Organization
      </h1>
    </div>
    <div class="mt-10 flex justify-center gap-3 md:gap-4">
      <tw-button :to="{name: 'StaticForOrganizationsPage'}" variant="amber" size="lg" block class="text-sm md:text-base w-[142px] md:w-[180px]">
        Get Started
      </tw-button>
      <tw-button :to="{name: 'StaticHowItWorksPage'}" size="lg" variant="light" block class="text-sm md:text-base w-[142px] md:w-[180px]">
        How it Works
      </tw-button>
    </div>
    <organization-register-modal ref="organizationRegisterModal" />
  </div>
</template>

<style scoped>

</style>
